<app-card
  title="Important Agreements"
  headerClasses="p-4 has-text-weight-bold is-size-4-mobile card-header-title numbered-header"
  contentClasses="p-4 card-body-background"
  data-qa-id="Order Agreements"
>
  <form [formGroup]="agreementsForm">
    @if (orderAgreements.introduction) {
      <p class="mb-4">{{ orderAgreements.introduction }}</p>
    }
    @for (agreement of orderAgreements.agreements; track $index) {
      <label class="checkbox mt-4 is-flex is-align-items-flex-start">
        <input
          type="checkbox"
          class="mt-1 mr-2"
          [formControlName]="'agreement_' + $index"
          [attr.data-qa-id]="agreement"
        />
        <span>{{ agreement }}</span>
      </label>
      @if (isInvalid(agreementsForm.get('agreement_' + $index))) {
        <div class="error">You must acknowledge this agreement</div>
      }
    }
  </form>
</app-card>
